module.exports = __webpack_public_path__ + "static/media/play-stone-boss-1.63f7b406.png";